module.exports = __webpack_public_path__ + "img/persona dreamdeal tech (3)-26.5ed57f45.png";